import { useContext } from 'react';
import { atom, useRecoilState } from 'recoil';
import { DataContext } from 'entries/common/widgets/context';

const defaultState = {
  wall: false,
  floor: false,
  ceiling: false,
  wall_single: false,
  wall_linear: false,
  land_plot: false,
  isInit: false,
};

const surfaceState = atom({
  key: 'surface',
  default: defaultState,
});

export const useSurfaceState = () => {
  const data = useContext(DataContext);
  const [surfaceFormState, setSurfaceState] = useRecoilState(surfaceState);

  const surface = Object.keys(data?.surfaces?.surface ?? {});
  const name = surface[0]?.toLowerCase();

  if (!surfaceFormState.isInit && data?.isSurfaceOne) {
    setSurfaceState({
      ...defaultState,
      [name]: true,
      isInit: true,
    });
  }

  return {
    surfaceFormState,
    setSurfaceState,
  };
};
